import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DatePipe, Location} from '@angular/common';
import {Kpi, KpiItem, Platform} from '../../../models/common';
import {Post, PostType} from '../../../models/post-overview';
import {InfluencerPostService} from '../../services/influencer-post/influencer-post.service';
import {CommonService} from '../../services/common/common.service';
import {AddPostToProject, InfluencerDetail, TopExposure} from '../../../models/influencer';
import {InfluencerService} from '../../services/influencer/influencer.service';
import {chartConfig, CommonConstant, EngagementGaugeChartColors, platformIconPath} from '../../app.constants';
import {PlaceholderVisibilityService} from '../../services/placeholder-visibility/placeholder-visibility.service';
import {UserService} from '../../services/user.service';
import {CampaignService} from '../../services/campaign/campaign.service';
import {AddInfluencersCampaign} from '../../../models/campaign/add-influencers-campaign';
import {AchooPopupComponent} from '../../core/achoo-popup/achoo-popup.component';
import {ModalService} from '../../services/modal/modal.service';
import {Project} from '../../../models/project/project';
import {ReferenceDataService} from '../../services/reference-data/reference-data.service';
import {DiscoverService} from '../../services/discover/discover.service';
import {PdfViewerService} from '../pdf-viewer/pdf-viewer.service';
import {Subscription} from 'rxjs/Subscription';
import { PdfExportService } from '../../services/export-pdf/pdf-export.service';
import {AbstractAchooComponent} from '../abstract-achoo.component';
import {
  ActionDetails,
  ActionSource,
  ActivePages,
  EventTrackerService,
  Page,
  TargetType,
  UserActionType
} from '../../services/event-tracker/event-tracker.service';
import {ActivePage} from '../../../models/event-tracker';
import {PieChartData} from '../../../models/chart';
import {NumberUtils} from '../../utils/number.utils';
import {TranslateService} from '@ngx-translate/core';
import {ObjectUtils} from '../../utils/object.utils';
import {CacheService} from '../../services/cache/cache.service';
import {CampaignsDetailComponent} from '../campaigns-add/campaign-detail.component';

@Component({
  selector: 'post-overview',
  templateUrl: './post-overview.component.html',
  styleUrls: ['./post-overview.component.scss']
})
export class PostOverviewComponent extends AbstractAchooComponent implements OnInit {

  public user: any;

  public postContent: Post;
  public postKpi: Kpi | null;
  public postActivityLineChartData: Array<object> | null;
  public postActivityGaugeChartData: Array<PieChartData>;
  public topExposures: TopExposure[] = [];
  public platforms: Platform[] = [];
  public platformIconUrl: string | null;

  public influencer: InfluencerDetail;
  public influencerGroupId: number | 0;
  public showCountryFlagIcon: boolean | true;

  public activeBottomBar: boolean;
  public isEnableAddToCampaign: boolean;
  public isEnableAddToProject: boolean;
  public showCreateNewProjectFragment: boolean;
  public campaignList: [any];
  public projectList: Project[];
  public countryList: [any];
  public selectedCampaign: AddInfluencersCampaign = new AddInfluencersCampaign();
  public selectedCampaignNotificationMsg: string;
  public newProject: Project = new Project();
  public projectName: string;
  @ViewChild('AlertAddPostToCampaignSuccess')
  public alertAddPostToCampaignSuccess: AchooPopupComponent;
  @ViewChild('AlertAddPostToCampaignError')
  public alertAddPostToCampaignError: AchooPopupComponent;
  @ViewChild('NotificationAfterAddPostToProject')
  public notificationAfterAddPostToProject: AchooPopupComponent;
  @ViewChild('AlertPdfDownloadPending')
  public alertPdfDownloadPending: AchooPopupComponent;

  public exportPdfSubcription: Subscription;

  public hideBackButton = false;
  public pieLegend: any = {};
  public enagagementChartConfig = {
    spacingTop: 8
  };

  // keep back link
  private fromPath: string;
  private influencerId: number;
  // flag to indicate whether we on Media Platform or Influencer Platform
  // Default on Media Platform
  public onInfluencerPlatform = false;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private location: Location,
              private influencerPostService: InfluencerPostService,
              private commonService: CommonService,
              private influencerService: InfluencerService,
              protected userService: UserService,
              private campaignService: CampaignService,
              private referenceDataService: ReferenceDataService,
              private discoverService: DiscoverService,
              private modalService: ModalService,
              private placeholderService: PlaceholderVisibilityService,
              private pdfViewerService: PdfViewerService,
              private pdfService: PdfExportService,
              private translate: TranslateService,
              private cacheService: CacheService,
              private eventTracker: EventTrackerService) {
    super(userService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.route.data.subscribe((data) => {
      if (data.onInfluencerPlatform) {
        this.onInfluencerPlatform = true;
        this.initializePostPageForInfluencerPlatform();
      } else {
        this.onInfluencerPlatform = false;
        this.intializePostPageForMediaPlatform();
      }
    });
    // get list countries
    this.countryList = this.referenceDataService.countries;
  }

  private intializePostPageForMediaPlatform() {
    this.route.queryParamMap.subscribe(params => {
      const influencerId = params.get('influencerId');
      const urlHash = params.get('urlHash');
      this.hideBackButton = params.get('hideBackButton') && (params.get('hideBackButton') === 'true');
      this.fromPath = params.get('from_path');

      this.influencerId = Number(influencerId);
      this.influencerGroupId = Number(params.get('influencerGroupId'));
      this.placeholderService.show(CommonConstant.INFLUENCER_BASIC_INFORMATION_HOLDER);

      this.getInfluencerDetails(influencerId);
      if (urlHash) {
        this.getPostContent(urlHash, influencerId);
        this.getRelatedPosts(Number(influencerId));
      }
    });
  }

  private initializePostPageForInfluencerPlatform() {
    this.route.params.subscribe((params) => {
      const urlHash = params.urlHash;
      const currentInfluencer = this.userService.getInfluencerInfo();
      if (currentInfluencer) {
        this.influencerId = currentInfluencer.id;
        this.getInfluencerDetails(currentInfluencer.id);
        this.getPostContent(urlHash, currentInfluencer.id);
        this.getRelatedPosts(Number(currentInfluencer.id));
      }
    });
  }

  // callback when switching account
  companyChangeCallback(companyId) {
    this.cacheService.get(`campaign_short_list_${companyId}`,
      this.campaignService.getCampaignShortListForCompany(companyId)).subscribe((res: any) => {
        this.campaignList = res.map(
          (campaign) => ({
            id: campaign.id,
            name: campaign.name,
            brief: campaign.brief
          })
        );
    });
    // load list project
    this.cacheService.get(`all_projects_of_advertiser_${companyId}`, this.userService.getAllProjectOfAdvertiser()).subscribe((res: any) => {
      if (!res || !res.data) {
        this.projectList = [];
      } else {
        this.projectList = res.data.map(
          (prj) => ({
            id: prj.id,
            name: prj.name,
            countries: prj.projectCountries.map(item => item.country.id),
            keywords: prj.projectKeywords.map(item => item.keyword)
          })
        );
      }
    });
  }

  private getInfluencerDetails(influencerId) {
    this.cacheService.get(`influencer_${influencerId}`,
      this.influencerService.getInfluencer(influencerId)).subscribe((data) => {
        this.influencer = data;
        this.showCountryFlagIcon = true;
        this.placeholderService.hide(CommonConstant.INFLUENCER_BASIC_INFORMATION_HOLDER);
    });
  }

  private getPostContent(urlHash, influencerId) {
    this.cacheService.get(`post_${urlHash}`, this.influencerPostService.getPostContent(urlHash, influencerId)).subscribe((data) => {
      this.postContent = data;
      if (!this.postContent) {
        return this.handleNotFoundPost();
      }
      const platform: Platform = this.postContent.channel ? this.postContent.channel.platform : this.postContent.platform;
      this.platformIconUrl = this.commonService.resolvePlatformIconUrl(platform.name);

      this.postActivityGaugeChartData = this.postContent.story && !this.postContent.authorized ? [] : this.extractGaugeChartData(this.postContent);
      this.postKpi = this.extractGlobalKpi(this.postContent);

      if (this.postContent.urlHash) {
        this.getPostDailyKpis(this.postContent.urlHash, influencerId, this.postContent);
      }

      // segment track event
      this.eventTracker.trackUserAction(UserActionType.VIEW, Page.POST, {
          id: this.postContent.urlHash,
          name: this.postContent.title,
          type: TargetType.POST
        }, undefined, undefined,
        this.activePage
      );
    });
  }

  private handleNotFoundPost() {
    if (this.onInfluencerPlatform) {
      return this.router.navigate(['dashboard', 'details']);
    } else {
      return this.router.navigate(['influencer', this.influencerId]);
    }
  }

  private extractGaugeChartData(postContent: Post): Array<PieChartData> {
    let gaugeChartData = new Array<PieChartData>();
    if (postContent.comments === 0 && postContent.playlists === 0 && postContent.dislikes === 0
      && postContent.shares === 0 && postContent.views === 0 && postContent.likes === 0) {
      return gaugeChartData;
    }

    let totalEngagements = postContent.comments + postContent.playlists + postContent.dislikes + postContent.shares + postContent.views + postContent.likes + postContent.replies;

    if (postContent.story && postContent.authorized) {
      totalEngagements = totalEngagements + postContent.tapsBack + postContent.tapsForward + postContent.exits;
    }

    if (postContent.postType === PostType.REEL) {
      totalEngagements += postContent.plays;
    }

    if (totalEngagements === 0) {
      return gaugeChartData;
    }

    if (postContent.views > 0) {
      gaugeChartData.push(
        {
          name: 'Views',
          y: postContent.views / totalEngagements,
          fracDigit: 1
        }
      );
    }

    if (postContent.likes > 0) {
      gaugeChartData.push(
        {
          name: 'Likes',
          y: postContent.likes / totalEngagements,
          fracDigit: 1
        }
      );
    }

    if (postContent.dislikes > 0) {
      gaugeChartData.push(
        {
          name: 'Dislikes',
          y: postContent.dislikes / totalEngagements,
          fracDigit: 1
        }
      );
    }

    if (postContent.comments > 0) {
      gaugeChartData.push(
        {
          name: 'Comments',
          y: postContent.comments / totalEngagements,
          fracDigit: 1
        }
      );
    }

    if (postContent.replies > 0) {
      gaugeChartData.push(
        {
          name: 'Replies',
          y: postContent.replies / totalEngagements,
          fracDigit: 1
        }
      );
    }

    if (postContent.shares > 0) {
      gaugeChartData.push(
        {
          name: 'Shares',
          y: postContent.shares / totalEngagements,
          fracDigit: 1
        }
      );
    }

    if (postContent.playlists > 0) {
      gaugeChartData.push(
        {
          name: 'Playlists',
          y: postContent.playlists / totalEngagements,
          fracDigit: 1
        }
      );
    }

    if (postContent.postType === PostType.REEL && postContent.plays > 0) {
      gaugeChartData.push(
        {
          name: this.translate.instant('page.post_overview.section_legend.plays'),
          y: postContent.plays / totalEngagements,
          fracDigit: 1
        }
      );
    }

    if (postContent.story && postContent.authorized) {
      gaugeChartData = gaugeChartData.concat(this.addNewTypeToGaugeChartData(postContent, totalEngagements));
    }

    return gaugeChartData;
  }

  private addNewTypeToGaugeChartData(postContent, totalEngagements) {
    const gaugeChartDataWithNewType = new Array<PieChartData>();

    if (postContent.tapsBack > 0) {
      gaugeChartDataWithNewType.push(
        {
          name: this.translate.instant('page.post_overview.section_legend.taps_back'),
          y: postContent.tapsBack / totalEngagements,
          fracDigit: 1
        }
      );
    }

    if (postContent.tapsForward > 0) {
      gaugeChartDataWithNewType.push(
        {
          name: this.translate.instant('page.post_overview.section_legend.taps_forward'),
          y: postContent.tapsForward / totalEngagements,
          fracDigit: 1
        }
      );
    }

    if (postContent.exits > 0) {
      gaugeChartDataWithNewType.push(
        {
          name: this.translate.instant('page.post_overview.section_legend.exits'),
          y: postContent.exits / totalEngagements,
          fracDigit: 1
        }
      );
    }

    return gaugeChartDataWithNewType;
  }

  private extractGlobalKpi(postContent: Post): Kpi {
    const impression = new KpiItem();
    impression.name = 'impresions';
    impression.value = postContent.impression;

    // the fallback value of IG impression value is reach
    if (postContent.impression === 0 && postContent.platform && postContent.platform.id === platformIconPath.instagram.id) {
      impression.value = postContent.reach;
    }

    const reach = new KpiItem();
    reach.name = 'reach';
    reach.value = postContent.reach;

    const engagement = new KpiItem();
    engagement.name = 'engagement';
    engagement.value = postContent.engagement;

    const impact = new KpiItem();
    impact.name = 'impact';
    impact.value = postContent.impact * 100;

    const globalKpi = new Kpi();
    globalKpi.engagement = engagement;
    globalKpi.reach = reach;
    globalKpi.impact = impact;
    globalKpi.impressions = impression;

    return globalKpi;
  }

  private getPostDailyKpis(urlHash, influencerId: number, currentPost: Post) {
    const today = new Date();
    today.setDate(today.getDate() - 30);
    const startDate = today.toISOString().split('T')[0];
    this.cacheService.get(`post_daily_kpis_${urlHash}`,
      this.influencerPostService.getPostDailyKpis(urlHash, influencerId, 30, startDate, null)).subscribe((res) => {
      if (res) {
        const chartData = res.chartData;
        this.postActivityLineChartData = this.commonService.normalizeDataForActivityLineChart(chartData);

        if (res.currentPost && res.currentPost.length > 0) {
          const currentPostDaily = res.currentPost[0];
          const currentPostDailyDate = new Date(currentPostDaily.date);
          const reachPoint = this.buildLineChartPoint('Reach Point', CommonConstant.REACHE_LINE_COLOR);
          reachPoint.data.push([currentPostDailyDate.getTime(), currentPostDaily.reach]);
          const impressionPoint = this.buildLineChartPoint('Impression Point', CommonConstant.IMPRESSION_LINE_COLOR);
          impressionPoint.data.push([currentPostDailyDate.getTime(), currentPostDaily.impression]);
          const engagementPoint = this.buildLineChartPoint('Engagement Point', CommonConstant.ENGAGEMENT_LINE_COLOR);
          engagementPoint.data.push([currentPostDailyDate.getTime(), currentPostDaily.engagement]);

          this.postActivityLineChartData.splice(0, 0, reachPoint);
          this.postActivityLineChartData.splice(0, 0, impressionPoint);
          this.postActivityLineChartData.splice(0, 0, engagementPoint);
        }
      }
    });
  }

  private buildLineChartPoint(name: string, color: string) {
    return {
      name: name,
      data: [],
      color: color,
      marker: {
        enable: true,
        fillColor: color,
        radius: 6,
      },
      showInLegend: false,
      dataLabels: {
        y: -5,
        enabled: true,
        useHTML: true,
        allowOverlap: true,
        formatter: function () {
          return '<div class="current-post-daily-kpi">' +
            '<span class="kpi-content">' + NumberUtils.normalizeNumberToString(this.y) +  '</span>' +
            '<span class="bottom-arrow"></span>' +
            '</div>';
        },
        style: {
          fontFamily: chartConfig.font.light,
          fontSize: '0.99rem',
          color: '#717D8D',
          top: '19px'
        }
      }
    };
  }

  private getRelatedPosts(influencerId: number) {
    this.cacheService.get(`related_posts_${influencerId}`,
      this.influencerPostService.getRelatedPosts(influencerId)).subscribe((res: any) => {
        this.topExposures = res;
    });
  }

  back() {
    if (!this.postContent) {
      return this.location.back();
    }
    this.cacheService.disableCacheRemoving(this.cachedKeys(this.postContent.urlHash, this.postContent.influencerId, this.companyId));
    if (this.fromPath) {
      const fromPathUrl = this.fromPath.split('?')[0];
      const fromPathRequestParams = ObjectUtils.parseRequestParamFromString(this.fromPath.split('?')[1], '=');
      return this.router.navigate([fromPathUrl], {queryParams: fromPathRequestParams});
    } else {
      return this.location.back();
    }
  }

  private cachedKeys(urlHash, influencerId, companyId) {
    return [
      `related_posts_${influencerId}`,
      `post_daily_kpis_${urlHash}`,
      `campaign_short_list_${companyId}`,
      `all_projects_of_advertiser_${companyId}`,
      `influencer_${influencerId}`,
      `post_${urlHash}`,
      `post_daily_kpis_${urlHash}`
    ];
  }

  hideAlertSuccess() {
    this.modalService.close();
  }

  hideBottomBar() {
    this.activeBottomBar = false;
    this.isEnableAddToCampaign = false;
    this.isEnableAddToProject = false;
  }

  showAddToCampaign() {
    this.activeBottomBar = true;
    this.isEnableAddToCampaign = true;
  }

  showAddToProject() {
    this.activeBottomBar = true;
    this.isEnableAddToProject = true;
  }

  addInfluencerToCampaign(addInfluencerCampaign: AddInfluencersCampaign) {
    const postPaths = [{
      urlHash: this.postContent.urlHash,
      influencerId: this.postContent.influencerId,
      url: this.postContent.url,
      relativepath: this.postContent.relativePath,
      publishDate: this.postContent.publishedDate,
      title: this.postContent.title,
      image: this.postContent.image,
      status: addInfluencerCampaign.is_accepted ? 'accepted' : 'invited',
      channelId: this.postContent.channel ? this.postContent.channel.id : null
    }];
    this.hideBottomBar();
    this.selectedCampaign = addInfluencerCampaign;
    this.selectedCampaignNotificationMsg = addInfluencerCampaign.campaign_name;
    this.campaignService.addPostsToCampaign(addInfluencerCampaign.campaign_id, postPaths).subscribe((res: any) => {
        this.showAlertSuccessAddInfluencerToCampaign();
        // track event to Segment
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
          id: addInfluencerCampaign.campaign_id,
          name: addInfluencerCampaign.campaign_name,
          type: TargetType.CAMPAIGN
        }, {
          action: UserActionType.UPDATE,
          source: ActionSource.PAGE,
          actionDetails: ActionDetails.ADDED_POSTS,
          ...addInfluencerCampaign,
          postUrlHash: this.postContent.urlHash,
          postTitle: this.postContent.title
        }, undefined,
          this.activePage
        );
        this.userService.triggerUpdateActivatedInfluencers();
      },
      (error) => {
        this.showAddToCampaign();
        const serverError = CampaignsDetailComponent.buildMessageErrorInArchive(error.error, this.translate);
        if (serverError.errorType === 'invalid level') {
          this.userService.doInvalidActionByLevel(CommonConstant.BASIC_CAMPAIGN_ACTION, serverError.errorMsg);
        } else {
          this.showAlertErrorAddInfluencerToCampaign();
        }
      });
  }

  showAlertSuccessAddInfluencerToCampaign() {
    this.modalService.open(this.alertAddPostToCampaignSuccess, undefined, true);
  }
  showAlertErrorAddInfluencerToCampaign() {
    this.modalService.open(this.alertAddPostToCampaignError, undefined, true);
  }

  showCreateProjectFragement() {
    // initialize value for new project
    this.newProject = new Project();
    this.newProject.id = 0;
    this.newProject.countries = [];
    // show project creation fragment
    this.isEnableAddToProject = false;
    this.showCreateNewProjectFragment = true;
  }

  afterCreateProjectSuccess(newPersistedProject) {
    if (newPersistedProject.isReloadList) {
      const newProject = new Project();
      newProject.name = newPersistedProject.projectName;
      newProject.id = newPersistedProject.projectId;
      newProject.countries = newPersistedProject.projectData.projectCountries.map(item => item.country.id);
      newProject.keywords = newPersistedProject.projectData.projectKeywords.map(item => item.keyword);
      this.projectList.push(newProject);
    }
    this.showCreateNewProjectFragment = false;
    this.isEnableAddToProject = true;
  }

  /**
   * using to add multiple post into project
   * @param {AddPostToProject} addPostToProject
   */
  addPostIntoProject(addPostToProject: AddPostToProject) {
    const postData = [{
      postUrlHash: this.postContent.urlHash,
      postRelativePath: this.postContent.relativePath,
      channelId: this.postContent.channel ? this.postContent.channel.id : null
    }];

    addPostToProject.posts = postData;
    this.discoverService.addPostsToProject(addPostToProject).subscribe((res: any) => {
      this.showNotificationAfterAddingPostToProject(addPostToProject.projectName);
      this.hideBottomBar();
      // track event to Segment
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.PROJECT, {
        id: addPostToProject.projectId,
        name: addPostToProject.projectName,
        type: TargetType.PROJECT
      }, {
        action: UserActionType.UPDATE,
        source: ActionSource.PAGE,
        actionDetails: ActionDetails.ADDED_POSTS,
        ...addPostToProject,
        postUrlHash: this.postContent.urlHash,
        postTitle: this.postContent.title
      }, undefined,
        this.activePage
      );
    });
  }

  showNotificationAfterAddingPostToProject(projectName) {
    this.projectName = projectName;
    this.modalService.open(this.notificationAfterAddPostToProject, undefined, true);
  }

  exportPDF(popper) {
    // cancel previous request
    if (this.exportPdfSubcription) {
      this.exportPdfSubcription.unsubscribe();
    }

    if (popper) {
      popper.hide();
    }

    this.modalService.open(this.alertPdfDownloadPending, null, true, CommonConstant.PDF_EXPORT_NOTIFICATION_SHOWING_TIME);

    const params = {
      influencerId: this.postContent.influencerId,
      urlHash: this.postContent.urlHash,
      activeAccount: this.userService.getCompanyId(),
      fullUrl: this.postContent.url,
      relativePath: this.postContent.relativePath
    };

    this.exportPdfSubcription = this.pdfViewerService.generatePostOverviewPdf(params, this.userService.getCompanyId()).subscribe((res: any) => {
      // track event to Segment
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.POST, {
        id: this.postContent.urlHash,
        name: this.postContent.title,
        type: TargetType.POST
      }, {
        action: UserActionType.EXPORT,
        source: ActionSource.BOTTOM_BAR,
      }, undefined,
        this.activePage
      );
    });
  }

  backToDashboard() {
    return this.router.navigate(['dashboard', 'home']);
  }

  get activePage(): ActivePage {
    return {
      type: ActivePages.POST,
      name: this.postContent.title,
      id: this.postContent.urlHash
    };
  }

  get isFreeUser() {
    return this.userService.isFreeUser();
  }

  get shouldShowFreemiumFallbackMessage() {
    return this.isFreeUser && !this.userService.isAdmin;
  }

  get fallbackTitle() {
    if (this.userService.isFreeUser() && !this.userService.isAdmin) {
      return this.translate.instant('common.invalid_action_by_levels_warning.fallback_title');
    } else {
      return null;
    }
  }

  get fallbackMessage() {
    if (this.userService.isFreeUser() && !this.userService.isAdmin) {
      return this.translate.instant('common.invalid_action_by_levels_warning.fallback_message');
    } else {
      return null;
    }
  }

  get enagagementFallbackTitle() {
    if (!this.postContent || (this.isFreeUser && !this.userService.isAdmin)) {
      return null;
    }
    return this.translate.instant('story.engagement.fallback_title');
  }

  get enagagementFallbackMessage() {
    if (!this.postContent || (this.isFreeUser && !this.userService.isAdmin)) {
      return null;
    }
    if (this.postContent.isStory) {
      return this.translate.instant('story.engagement.fallback_msg');
    } else {
      return this.translate.instant('page.post_overview.engagement_fallback_msg');
    }
  }

  /**
   * data will be used to send to Segment
   * @returns {{action: UserActionType; item: Page; target: ({type: Page} | {id: (number | any); name: (string | any); type: TargetType}); params: {action: UserActionType; source: ActionSource; actionDetails: ActionDetails}; activePage: {type: ActivePages}}}
   */
  actionData(target) {
    const item = target === 'project' ? Page.PROJECT : Page.CAMPAIGN;
    return {
      action: UserActionType.ACTION, item,
      target: {
        type: item
      },
      params: {
        action: UserActionType.UPDATE,
        source: ActionSource.ACTION_VIEW,
        actionDetails: ActionDetails.ADDED_POSTS,
      },
      activePage: {
        type: ActivePages.POST,
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/main/post-overview/post-overview.component.ts